import { Paragraph3 } from '@cian/ui-kit';

import * as React from 'react';

import * as styles from './styles.css';

export const CommercialOwnerIcon: React.FC = () => (
  <div className={styles['root']}>
    <Paragraph3 color="white_100">Собственник</Paragraph3>
  </div>
);

CommercialOwnerIcon.displayName = 'CommercialOwnerIcon';
